"use client";

import ButtonV2 from "@/components/ui-v2/ButtonV2";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="min-h-screen bg-white px-4 py-12">
      <div className="mx-auto max-w-2xl rounded-2xl border border-red-200 bg-red-50 p-6 text-red-900">
        <h2 className="text-lg font-semibold">Yazı yüklenemedi</h2>
        <p className="mt-2 text-sm text-red-700">
          Blog yazısı açılırken bir sorun oluştu.
        </p>
        <ButtonV2
          type="button"
          variant="ghost"
          onClick={reset}
          className="mt-4 rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-500"
        >
          Tekrar dene
        </ButtonV2>
      </div>
    </main>
  );
}
